<template>
  <div>
    <BModal
      id="region-selector-modal"
      ref="regionSelectorModal"
      centered
      lazy
      no-close-on-backdrop
      header-class="border-0"
    >
      <template #header>
        <h5 class="modal-title">{{ translate('selectRegion', labels, 'shared_Regions') }}</h5>
      </template>
      <div class="mt-0 mt-md-4 px-3">
        <b-error v-if="error">
          {{ translate('invalidQueryRegion', labels, 'shared_CommonErrors') }}
        </b-error>
        <BFormGroup class="d-flex justify-content-center mb-0">
          <div>
            <BFormRadio
              v-for="region in regions"
              :key="region.key"
              v-model="selectedRegion"
              name="region-radio"
              :value="region.key"
              class="my-2"
            >
              {{ region.translation }}
            </BFormRadio>
          </div>
        </BFormGroup>
      </div>
      <template #footer>
        <div class="text-end d-flex flex-wrap d-md-block w-100">
          <BButton
            class="mt-2 mt-md-0 ms-md-3 order-1 col-12 col-md-auto"
            variant="outline-primary"
            @click="logout()"
          >
            {{ translate('cancelAndLogout', labels, 'shared_CommonFunctional') }}
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            class="mt-2 mt-md-0 ms-md-3 order-0 col-12 col-md-auto d-inline-flex justify-content-center align-items-center"
            :disabled="regions.length === 0"
            @click="setRegion()"
          >
            {{ translate('setRegion', labels, 'shared_Regions') }}
          </BButton>
        </div>
      </template>
    </BModal>
  </div>
</template>

<script setup lang="ts">
import {getCurrentInstance, onMounted, ref} from 'vue'
import BError from '@/components/ui/BError.vue'
import {signOut} from '@dxp-common-components-updated/utils-global'
import {useCommon} from '@/composables/useCommon'

type Region = {
  key: string
  translation: string
}

const props = withDefaults(defineProps<{
  regions?: Region[]
  error?: boolean
}>(), {
  regions: () => []
})

const emit = defineEmits<{(e: 'select', value: string): void
}>()

const {labels, translate} = useCommon()
const instance = getCurrentInstance()
const regionSelectorModal = ref<any>(null)
const selectedRegion = ref('')

onMounted(() => {
  selectedRegion.value = props.regions[0] && props.regions[0].key
  regionSelectorModal.value?.show()
})

function setRegion(): void {
  emit('select', selectedRegion.value)
  regionSelectorModal.value?.hide()
}

async function logout(): Promise<void> {
  const auth = instance?.appContext.config.globalProperties.$auth
  if (auth) {
    await signOut.call({$auth: auth})
  }
}
</script>

<style scoped>
:deep(.form-check) {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-left: 0;
}
:deep(.form-check-input) {
  float: none;
  margin: 0;
  flex-shrink: 0;
}
:deep(.form-check-label) {
  margin: 0;
}
</style>

